import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CouponsActions,
  FetchEmailLogsFailAction,
  FetchEmailLogsRequestAction,
  FetchEmailLogsSuccessAction,
  ResetCoupon,
  SendEmailFailAction,
  SendEmailRequestAction,
  SendEmailSuccessAction,
  stateStatusType,
} from "./actionType";
import { EmailLogState, initialState } from "./state";

const fetchEmailLogsRequest = (
  state: EmailLogState,
  action: FetchEmailLogsRequestAction
) => {
  return updateObject(state, {
    fetchEmailLogsState: {
      ...state.fetchEmailLogsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchEmailLogsSuccess = (
  state: EmailLogState,
  action: FetchEmailLogsSuccessAction
) => {
  return updateObject(state, {
    fetchEmailLogsState: {
      ...state.fetchEmailLogsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      emailLogs: action.payload,
    },
  });
};

const fetchEmailLogsFail = (
  state: EmailLogState,
  action: FetchEmailLogsFailAction
) => {
  return updateObject(state, {
    fetchEmailLogsState: {
      ...state.fetchEmailLogsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      coupon: null,
    },
  });
};

//create
const sendMailRequest = (
  state: EmailLogState,
  action: SendEmailRequestAction
) => {
  return updateObject(state, {
    genericEmailLogsState: {
      ...state.genericEmailLogsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const sendMailSuccess = (
  state: EmailLogState,
  action: SendEmailSuccessAction
) => {
  return updateObject(state, {
    genericEmailLogsState: {
      ...state.genericEmailLogsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchEmailLogsState: {
      ...state.fetchEmailLogsState,
      status: stateStatusType.SUCCESS,
    },
  });
};

const sendMailFail = (
  state: EmailLogState,
  action: SendEmailFailAction
) => {
  return updateObject(state, {
    genericEmailLogsState: {
      ...state.genericEmailLogsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchEmailLogsState: {
      ...state.fetchEmailLogsState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};

const resetCoupon = (state: EmailLogState, action: ResetCoupon) => ({
  ...state,
  genericEmailLogsState: { ...initialState.genericEmailLogsState },
});

const emailogs = (state = initialState, action: CouponsActions) => {
  switch (action.type) {
    case actionTypes.FETCH_EMAIL_LOGS_REQUEST:
      return fetchEmailLogsRequest(state, action);
    case actionTypes.FETCH_EMAIL_LOGS_SUCCESS:
      return fetchEmailLogsSuccess(state, action);
    case actionTypes.FETCH_EMAIL_LOGS_FAIL:
      return fetchEmailLogsFail(state, action);
    case actionTypes.SEND_EMAIL_REQUEST:
      return sendMailRequest(state, action);
    case actionTypes.SEND_EMAIL_SUCCESS:
      return sendMailSuccess(state, action);
    case actionTypes.SEND_EMAIL_FAIL:
      return sendMailFail(state, action);
    case actionTypes.RESET_EMAIL:
      return resetCoupon(state, action);
    default:
      return state;
  }
};

export default emailogs;
